import React, { useCallback } from 'react';

import useStyles from './keepChallengeBtn.styles';
import Button from 'components/Button';
import { useTranslation } from 'react-i18next';
import Typography from 'components/Typography';
import Icon, { IconsType } from 'components/Icon';
import Tooltip from 'components/ToolTip';
import { useHistory, useLocation } from 'react-router-dom';
import { Pages } from 'interfaces/main';
import analyticsManager from 'helpers/analyticsManager';
import { mixPanelEventsTypes } from 'helpers/mixPanel';
import { useMixpanelData } from 'features/prop/hooks/useKeeperMixpanelData';

interface KeepChallengeBtnProps {
    plan: any;
    challenge: any;
}

const KeepChallengeBtn: React.FunctionComponent<KeepChallengeBtnProps> = ({ plan, challenge }) => {
    const classes = useStyles();
    const { t } = useTranslation('prop');
    const location = useLocation();
    const history = useHistory();
    const isPlatformPage =
        location.pathname === `/${Pages.PLATFORMS}/plan-statistics` || location.pathname === `/${Pages.PLATFORMS}/home`;
    const mixPanelData = useMixpanelData(undefined, challenge);

    const redirectToKeeperCheckout = useCallback(() => {
        const newUrl = `/${Pages.PROP}/${Pages.PROP__CHECKOUT}?planId=${plan?.pPlan?.planId}&challengeId=${challenge?.id}&keeper=true`;
        history.push(newUrl);
    }, [history, plan, challenge]);

    const handleClick = React.useCallback(() => {
        if (isPlatformPage) {
            analyticsManager.trackEvent(mixPanelEventsTypes.KEEPER_WT_EXTENDMYLIMITBTN, mixPanelData);
        }
        redirectToKeeperCheckout();
    }, [isPlatformPage, redirectToKeeperCheckout, mixPanelData]);

    const isCheckoutPage = location.pathname === `/${Pages.PROP}/${Pages.PROP__CHECKOUT}`;

    if (!isPlatformPage || isCheckoutPage) {
        return null;
    }

    return (
        <div className={classes.btn_wrapper}>
            <Tooltip
                title={<span className={classes.tooltip_text}>{t('prop_keep_btn_tooltip')}</span>}
                placement="top"
                tooltipClass={classes.keep_tooltip}
            >
                <Button onClick={handleClick} className={classes.propKeepBtn} variant="contained" color="primary">
                    <Icon name={IconsType.speedMeter} />
                    <Typography variant="tMdSemibold">{t('prop_keep_btn')}</Typography>
                </Button>
            </Tooltip>
        </div>
    );
};

export default KeepChallengeBtn;
